import { render, staticRenderFns } from "./publishedFail.vue?vue&type=template&id=88206344&"
import script from "./publishedFail.vue?vue&type=script&lang=js&"
export * from "./publishedFail.vue?vue&type=script&lang=js&"
import style0 from "./publishedFail.vue?vue&type=style&index=0&id=88206344&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports